// utils/dateUtils.js
export const normalizeDate = (date) => {
  const d = new Date(date);
  d.setUTCHours(12, 0, 0, 0);
  return d;
};

export const getISODate = (date) => {
  return normalizeDate(date).toISOString();
};

export const isSameDate = (date1, date2) => {
  const d1 = normalizeDate(date1);
  const d2 = normalizeDate(date2);
  return d1.getTime() === d2.getTime();
};

export const getDateWithTime = (date, hours = 12, minutes = 0, seconds = 0) => {
  const d = new Date(date);
  d.setUTCHours(hours, minutes, seconds, 0);
  return d;
};

export const nextDay = (d, direct) => {
  const date = normalizeDate(d);
  const timeDay = 24 * 60 * 60 * 1000;
  return direct === 'prev' 
    ? new Date(date.getTime() - timeDay).toISOString() 
    : new Date(date.getTime() + timeDay).toISOString();
};